import React, { useEffect, useState } from "react";
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SpamIcon from "@mui/icons-material/ReportProblem";
import PeopleIcon from "@mui/icons-material/People";
import CategoryModal from "./Modal/CategoryModal.js";
import Snackbar from "../utils/snackbar/Snackbar.js";
import { withRouter } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import { getData } from "../../restfulservices/httpHandler.js";
import { Tooltip, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import CryptoJS from "crypto-js";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import style from "./styles.module.css";

const ManageContent = () => {
  const [filteredData, setFilteredData] = React.useState(false);
  const [usercount, setUserCount] = useState(null);
  const [alert, setAlert] = useState(false);
  const [page, setPage] = React.useState(1);
  const [activeButton, setActiveButton] = useState("upcoming");
  const [activeUser, setActiveUser] = React.useState(false);
  const [editModal, setEditModal] = React.useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [contentToSpam, setContentToSpam] = useState(null);

  // Bookings popup state
  const [bookingsDialogOpen, setBookingsDialogOpen] = useState(false);
  const [selectedBookings, setSelectedBookings] = useState([]);
  const [selectedContentTitle, setSelectedContentTitle] = useState("");

  const limit = 10;
  const decryptionKey = process.env.REACT_APP_SECRET_KEY;

  const decryptEmail = (encryptedEmail) => {
    try {
      return CryptoJS.AES.decrypt(encryptedEmail, decryptionKey).toString(
        CryptoJS.enc.Utf8
      );
    } catch {
      return "N/A";
    }
  };

  const fetchpastcontent = async () => {
    const res1 = await getData(
      `v1/content/getPastForDashboard?page=${page}&limit=${limit}`
    );
    setFilteredData(res1?.data?.data?.past);
    setUserCount(res1?.data?.data?.total);
  };

  const fetchupcomingcontent = async () => {
    const res2 = await getData(
      `v1/content/getUpcomingForDashboard?page=${page}&limit=${limit}`
    );
    setFilteredData(res2?.data?.data?.upcoming);
    setUserCount(res2?.data?.data?.total);
  };

  const markContentAsSpam = async (id) => {
    try {
      const response = await getData(`v1/content/markedContentAsSpam?id=${id}`);
      if (response?.status === 200) {
        setAlert("Content marked as spam successfully");
        fetchupcomingcontent();
      } else {
        setAlert("Failed to mark content as spam");
      }
    } catch (error) {
      setAlert("An error occurred while marking content as spam");
    }
  };

  useEffect(() => {
    fetchupcomingcontent();
  }, [page]);

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const isLoading = !filteredData;
  const showData = !isLoading;
  const details = [];

  !isLoading &&
    filteredData.forEach((val, index) => {
      const decryptedEmail = decryptEmail(val?.user?.email);

      details.push([
        index + 1,
        val?.user?.name,
        decryptedEmail,
        val?.contentType,
        val?.category?.name,
        // Bookings button
        <React.Fragment>
          <Tooltip title="View Bookings">
            <IconButton
              onClick={() => {
                setSelectedBookings(val?.bookings || []);
                setSelectedContentTitle(val?.category?.name || "Content");
                setBookingsDialogOpen(true);
              }}
            >
              <PeopleIcon />
            </IconButton>
          </Tooltip>
          <span
            style={{
              fontSize: "11px",
              fontWeight: "bold",
              background: "#3f51b5",
              color: "#fff",
              borderRadius: "50%",
              padding: "2px 6px",
              marginLeft: "-8px",
              verticalAlign: "top",
            }}
          >
            {val?.totalBookings || 0}
          </span>
        </React.Fragment>,
        <React.Fragment>
          <Tooltip title="Details">
            <IconButton
              onClick={() => {
                setActiveUser(val);
                setEditModal(true);
              }}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>,
        <React.Fragment>
          <Tooltip title="Mark as Spam">
            <IconButton
              onClick={() => {
                setContentToSpam(val._id);
                setDialogOpen(true);
              }}
            >
              <SpamIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>,
      ]);
    });

  const handleDialogClose = () => {
    setDialogOpen(false);
    setContentToSpam(null);
  };

  const handleConfirmSpam = () => {
    markContentAsSpam(contentToSpam);
    handleDialogClose();
  };

  return (
    <GridContainer>
      {activeUser && (
        <CategoryModal
          type="EDIT"
          userData={activeUser}
          open={editModal}
          onClose={() => {
            setEditModal(false);
            setActiveUser(false);
          }}
          onDone={() => {
            setEditModal(false);
            setActiveUser(false);
          }}
          setAlert={(msg) => setAlert(msg)}
        />
      )}
      <Snackbar
        open={alert}
        handleClose={() => setAlert(false)}
        message={alert}
      />
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>Manage Events</h4>
              <div className={style.buttons}>
                <Button
                  color={activeButton === "upcoming" ? "secondary" : "white"}
                  variant="contained"
                  onClick={() => {
                    setActiveButton("upcoming");
                    fetchupcomingcontent();
                  }}
                >
                  Upcoming
                </Button>
                <Button
                  color={activeButton === "past" ? "secondary" : "white"}
                  variant="contained"
                  onClick={() => {
                    setActiveButton("past");
                    fetchpastcontent();
                  }}
                >
                  Past
                </Button>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading && (
              <div className={style.loader}>
                <CircularProgress />
              </div>
            )}
            {showData && (
              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "S.N",
                  "Name",
                  "Email",
                  "Content Type",
                  "Category",
                  "Bookings",
                  "View",
                  "Spam",
                ]}
                tableData={details}
              />
            )}
          </CardBody>
        </Card>
      </GridItem>

      {/* ── Spam Confirm Dialog ── */}
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="confirm-dialog-title"
      >
        <DialogTitle id="confirm-dialog-title">Confirm Action</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to mark this content as spam?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmSpam} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Bookings Detail Dialog ── */}
      <Dialog
        open={bookingsDialogOpen}
        onClose={() => setBookingsDialogOpen(false)}
        maxWidth="md"
        fullWidth
        aria-labelledby="bookings-dialog-title"
      >
        <DialogTitle id="bookings-dialog-title">
          Bookings for — <strong>{selectedContentTitle}</strong>
          <span
            style={{
              marginLeft: "10px",
              fontSize: "13px",
              color: "#888",
              fontWeight: "normal",
            }}
          >
            ({selectedBookings.length} total)
          </span>
        </DialogTitle>
        <DialogContent dividers>
          {selectedBookings.length === 0 ? (
            <Typography
              style={{ textAlign: "center", padding: "20px", color: "#999" }}
            >
              No bookings found for this content.
            </Typography>
          ) : (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr
                  style={{
                    backgroundColor: "#3f51b5",
                    color: "#fff",
                    textAlign: "left",
                  }}
                >
                  {["S.N", "Name", "Email", "Ticket Type", "Payment Status", "Booked At"].map(
                    (head) => (
                      <th
                        key={head}
                        style={{ padding: "10px 14px", fontSize: "13px" }}
                      >
                        {head}
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {selectedBookings.map((booking, idx) => (
                  <tr
                    key={booking._id}
                    style={{
                      backgroundColor: idx % 2 === 0 ? "#f9f9f9" : "#fff",
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    <td style={{ padding: "10px 14px", fontSize: "13px" }}>
                      {idx + 1}
                    </td>
                    <td style={{ padding: "10px 14px", fontSize: "13px" }}>
                      {booking?.userDetails?.name || "N/A"}
                    </td>
                    <td style={{ padding: "10px 14px", fontSize: "13px" }}>
                      {decryptEmail(booking?.userDetails?.email)}
                    </td>
                    <td style={{ padding: "10px 14px", fontSize: "13px" }}>
                      <span
                        style={{
                          padding: "3px 10px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "#fff",
                          backgroundColor:
                            booking?.ticketType === "Royal"
                              ? "#9c27b0"
                              : booking?.ticketType === "Vip"
                                ? "#f57c00"
                                : "#4caf50",
                        }}
                      >
                        {booking?.ticketType || "N/A"}
                      </span>
                    </td>
                    <td style={{ padding: "10px 14px", fontSize: "13px" }}>
                      <span
                        style={{
                          padding: "3px 10px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "#fff",
                          backgroundColor:
                            booking?.price === "Settled" ? "#4caf50" : "#f44336",
                        }}
                      >
                        {booking?.price || "N/A"}
                      </span>
                    </td>
                    <td style={{ padding: "10px 14px", fontSize: "13px" }}>
                      {booking?.createdAt
                        ? new Date(booking.createdAt).toLocaleString()
                        : "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setBookingsDialogOpen(false)}
            color="primary"
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <div
        style={{ width: "100vw", display: "flex", justifyContent: "center" }}
      >
        <Pagination
          count={Math.ceil(parseInt(usercount) / limit)}
          page={page}
          onChange={handleChangePage}
        />
      </div>
    </GridContainer>
  );
};

const mapStateToProps = (state) => ({
  user: state.appReducer.user,
});

export default withRouter(connect(mapStateToProps)(ManageContent));